/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_home_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toolverse is available in 10 languages, including English and German, with more being added. Switch languages from the footer on any page — the interface, calculators, and F1 Fantasy tools all translate, so you get the same accurate numbers no matter which language you read them in.`)
};

const es_home_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toolverse está disponible en 10 idiomas, incluidos inglés y alemán, y se van añadiendo más. Cambia de idioma desde el pie de página en cualquier vista — la interfaz, las calculadoras y las herramientas de F1 Fantasy se traducen todas, así que obtienes los mismos números exactos sin importar en qué idioma los leas.`)
};

const de_home_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toolverse ist in 10 Sprachen verfügbar, darunter Englisch und Deutsch, weitere kommen hinzu. Wechsle die Sprache über den Footer auf jeder Seite — die Oberfläche, die Rechner und die F1-Fantasy-Werkzeuge werden alle übersetzt, sodass du unabhängig von der gewählten Sprache dieselben präzisen Zahlen erhältst.`)
};

const nl_home_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toolverse is beschikbaar in 10 talen, waaronder Engels en Duits, met meer talen in aantocht. Wissel van taal via de footer op elke pagina — de interface, de calculators en de F1 Fantasy-tools vertalen allemaal mee, zodat je dezelfde accurate cijfers krijgt, ongeacht in welke taal je ze leest.`)
};

const fr_home_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toolverse est disponible en 10 langues, dont l’anglais et l’allemand, avec d’autres à venir. Changez de langue depuis le pied de page de n’importe quelle page — l’interface, les calculateurs et les outils F1 Fantasy sont tous traduits, afin que vous obteniez les mêmes chiffres précis quelle que soit la langue dans laquelle vous les lisez.`)
};

const it_home_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toolverse è disponibile in 10 lingue, incluse inglese e tedesco, con altre in arrivo. Cambia lingua dal footer di qualsiasi pagina — l'interfaccia, i calcolatori e gli strumenti F1 Fantasy vengono tutti tradotti, così ottieni gli stessi numeri accurati indipendentemente dalla lingua in cui li leggi.`)
};

const pt_br2_home_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A Toolverse está disponível em 10 idiomas, incluindo inglês e alemão, com mais sendo adicionados. Troque de idioma pelo rodapé em qualquer página — a interface, as calculadoras e as ferramentas de F1 Fantasy são todas traduzidas, então você recebe os mesmos números precisos independentemente do idioma em que os lê.`)
};

const pt_home_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A Toolverse está disponível em 10 idiomas, incluindo inglês e alemão, com mais a serem adicionados. Mude de idioma a partir do rodapé em qualquer página — a interface, as calculadoras e as ferramentas de F1 Fantasy traduzem-se todas, para que obtenha os mesmos números precisos independentemente do idioma em que os lê.`)
};

const ja_home_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toolverseは英語やドイツ語を含む10言語に対応しており、対応言語は今後も追加されていきます。どのページでもフッターから言語を切り替えられます — インターフェース、計算機、F1ファンタジーツールはすべて翻訳されるため、どの言語で読んでも同じ正確な数値が得られます。`)
};

const zh_home_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toolverse 目前支持 10 种语言，包括英语和德语，还会持续增加。在任意页面的页脚即可切换语言——界面、计算器和 F1 Fantasy 工具都会翻译，无论你用哪种语言阅读，得到的都是同样精准的数字。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const home_faq3_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.home_faq3_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("home_faq3_a", locale)
	if (locale === "en") return en_home_faq3_a(inputs)
	if (locale === "es") return es_home_faq3_a(inputs)
	if (locale === "de") return de_home_faq3_a(inputs)
	if (locale === "nl") return nl_home_faq3_a(inputs)
	if (locale === "fr") return fr_home_faq3_a(inputs)
	if (locale === "it") return it_home_faq3_a(inputs)
	if (locale === "pt-BR") return pt_br2_home_faq3_a(inputs)
	if (locale === "pt") return pt_home_faq3_a(inputs)
	if (locale === "ja") return ja_home_faq3_a(inputs)
	return zh_home_faq3_a(inputs)
};